/** Reported series — teal aligned with platform-insight mockups. */
export const LIVESTREAMING_REPORTED_AREA_COLOR = '#2dd4bf';
/** Removed series — rose accent for contrast vs reported. */
export const LIVESTREAMING_REMOVED_AREA_COLOR = '#fb7185';

const getLivestreamingMonthlyTrendOptions = (categories, view = 'reported') => {
  const isDark = localStorage.getItem('appMode') === 'dark';
  const axisTextColor = isDark ? '#e8e8e8' : '#212529';
  const themeFont =
    getComputedStyle(document.body).getPropertyValue('--bs-body-font-family').trim() || 'Arial, sans-serif';
  const themeFontWeight = getComputedStyle(document.body).getPropertyValue('--bs-body-font-weight').trim() || '400';
  const inverseRgb = getComputedStyle(document.body).getPropertyValue('--bs-inverse-rgb').trim();
  const gridLine = isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)';
  const lineColor = view === 'removed' ? LIVESTREAMING_REMOVED_AREA_COLOR : LIVESTREAMING_REPORTED_AREA_COLOR;

  return {
    chart: { type: 'area', toolbar: { show: false }, fontFamily: themeFont },
    colors: [lineColor],
    dataLabels: { enabled: false },
    stroke: { curve: 'smooth', width: 2 },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.5,
        opacityTo: 0.06,
        stops: [0, 90, 100],
      },
    },
    grid: {
      borderColor: gridLine,
      strokeDashArray: 0,
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } },
    },
    xaxis: {
      type: 'category',
      categories,
      axisTicks: { show: true, borderType: 'solid', color: `rgba(${inverseRgb}, .25)`, height: 6 },
      axisBorder: { show: true, color: `rgba(${inverseRgb}, .25)`, height: 1 },
      labels: {
        style: { colors: axisTextColor, fontSize: '12px', fontFamily: themeFont, fontWeight: themeFontWeight },
      },
    },
    yaxis: {
      labels: {
        formatter: value => Math.round(value),
        style: { colors: axisTextColor, fontSize: '12px', fontFamily: themeFont, fontWeight: themeFontWeight },
      },
    },
    tooltip: {
      theme: isDark ? 'dark' : 'light',
      shared: false,
      intersect: false,
      y: {
        formatter: val => String(Math.round(Number(val) || 0)),
      },
    },
    legend: { show: false },
  };
};

export default getLivestreamingMonthlyTrendOptions;
